module.exports = __webpack_public_path__ + "assets/img/12_139_big.49eaa53a.jpg";